function generateId() {
  const arr = new Uint8Array(10);
  return Array.from(window.crypto.getRandomValues(arr), dec => dec.toString(16).padStart(2, '0')).join('');
}

export { generateId as g };
